export const SpeakerReadWrapper = ({ children }: { children: React.ReactNode }) => {
	return <div className="martha-read">{children}</div>;
};
